export const DEFAULT_LIST_ID = 'ALL';
export const GROUP_AUTOCOMPLETE = 'GROUP_AUTOCOMPLETE';
export const RULE_AUTOCOMPLETE = 'RULE_AUTOCOMPLETE';
